/* eslint-disable no-param-reassign */
import { SystemFuncArgs } from '$legacyecstatic';
import { Components } from 'editor/components';
import MoveBoxCPInteraction from 'editor/components/interactions/MoveBoxCPInteraction';
import MoveMarkupInteraction from 'editor/components/interactions/MoveMarkupInteraction';
import MapboxMap from 'editor/components/map/MapboxMap';
import MapboxTool, { MapboxTools } from 'editor/components/map/MapboxTool';

export const configureToolComponents = [MapboxTool, MapboxMap];

export function configureTool(args: SystemFuncArgs<Components>): void {
  const { world, components } = args;
  const toolComp = components.get(MapboxTool);
  const mapComp = components.get(MapboxMap);

  if (mapComp?.map) {
    const mbcpi = world.locate(MoveBoxCPInteraction);
    const mlcpi = world.locate(MoveBoxCPInteraction);
    const mmi = world.locate(MoveMarkupInteraction);

    switch (toolComp.tool) {
      case MapboxTools.Pointer:
        if (mbcpi || mlcpi || mmi) {
          if (mapComp.map.dragPan.isEnabled()) {
            mapComp.map.dragPan.disable();
          }
        } else if (!mapComp.map.dragPan.isEnabled()) {
          mapComp.map.dragPan.enable();
        }
        break;

      case MapboxTools.PlacePunch:
        if (mmi) {
          if (mapComp.map.dragPan.isEnabled()) {
            mapComp.map.dragPan.disable();
          }
        } else if (!mapComp.map.dragPan.isEnabled()) {
          mapComp.map.dragPan.enable();
        }
        break;

      default:
    }
  }
}
